
    let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
    items.forEach(item => {
        
        item.addEventListener("mouseover", () => {
            item.setAttribute("open", true);
            if(item.hasAttribute('open')){
            item.querySelector(".mega-menu__content").classList.add('menu-active')
            item.querySelector(".link-menu-m").classList.add('blue-over')
          }             
        }); 
        item.addEventListener("mouseleave", () => {
        item.querySelector(".mega-menu__content").classList.remove('menu-active')
          item.querySelector(".link-menu-m").classList.remove('blue-over')
            });
    });
  const megaMenuTrigger = document.querySelector('.trigger-mega')
  const megaMenuContainer = document.querySelector('.content-menu')
  megaMenuTrigger.addEventListener("mouseover", () => {
    megaMenuContainer.classList.add('megamenuopening')
    megaMenuContainer.classList.remove('megamenuclosing')
  });
  megaMenuTrigger.addEventListener("mouseleave", () => {
    megaMenuContainer.classList.remove('megamenuopening')
    megaMenuContainer.classList.add('megamenuclosing')
  })
